import React from 'react'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { Table, Form, Button } from '_zari/core'

import AplicarDescuentoModal from './modals/aplicarDescuento'
import ActualizarComentarioModal from './modals/actualizarComentario'
import HistorialComprasModal from './modals/historialCompras'
import StockSedesModal from './modals/stocksSedes'
import ActualizarCentroCostoModal from './modals/actualizarCentroCosto'

import PlacaSelect from './placa'

const FilaDetalleTemplate = ({
  flagNota13,
  index,
  row,
  idSocio,
  flagModificarPrecioVenta,
  flagPermitirVentaSinStock,
  actualizarFilaHandler,
  actualizarComentarioHandler,
  eliminarFilaHandler,
  flagEditarComentarios
}) => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const [cantidad, setCantidad] = React.useState(row.cantidad || '')
  const [precio, setPrecio] = React.useState(row.precio || '')
  const [flagGratuito, setFlagGratuito] = React.useState(row.flagGratuito || false)
  const [_idPlacaSocio, setIdPlacaSocio] = React.useState(row._idPlacaSocio || '')
  const [tipoInputCantidad, setTipoInputCantidad] = React.useState(row.tipoInputCantidad || 'select')

  const [mostrarModalHistorialCompras, setMostrarModalHistorialCompras] = React.useState(false)
  const [mostrarAplicarDescuentoModal, setMostrarAplicarDescuentoModal] = React.useState(false)
  const [mostrarActualizarComentarioModal, setMostrarActualizarComentarioModal] = React.useState(false)
  const [mostrarStockSedesModal, setMostrarStockSedesModal] = React.useState(false)
  const [mostrarActualizarCentroCostoModal, setMostrarActualizarCentroCostoModal] = React.useState(false)

  const keyUpCantidadHandler = e => {
    const keyCode = e.keyCode

    let __focusCantidad = true
    let __focusPrecio = false
    let __focusDescuento = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      __focusCantidad = false
      saltarCampo = true

      // if (__adminContext.valoresConfiguracionUsuario.permisoVentas_Precio) {
      __focusPrecio = true
      // } else {
      // saltarFila = true
      // }
    }
    actualizarFilaHandler({
      ...row,
      cantidad,
      precio,
      __focusCantidad,
      __focusPrecio,
      __focusDescuento,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownCantidadHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const changePrecioHandler = e => {
    const keyCode = e.keyCode
    const selectedValue = e.target.value

    let __focusCantidad = false
    let __focusPrecio = false
    let __focusDescuento = false
    let saltarFila = false
    let saltarCampo = false

    const selectedPrecio = row.precios.filter(x => x._id === selectedValue)[0]
    let _idProductoPresentacionPrecio = selectedPrecio._id
    let precio = selectedPrecio.precio
    setPrecio(precio)

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }

    actualizarFilaHandler({
      ...row,
      tipoInputCantidad,
      cantidad,
      _idProductoPresentacionPrecio,
      precio,
      __focusCantidad,
      __focusPrecio,
      __focusDescuento,
      saltarFila,
      saltarCampo
    })
  }

  const keyUpPrecioSelectHandler = e => {
    const keyCode = e.keyCode

    if (keyCode === 13 || keyCode === 9) {
      let __focusPrecio = false
      let __focusPlaca = false
      let saltarFila = true
      let saltarCampo = true

      if (__adminContext.valoresConfiguracionCompania.flagGrifo && idSocio) {
        __focusPrecio = false
        __focusPlaca = true
        saltarFila = false
        saltarCampo = true
      }

      actualizarFilaHandler({
        ...row,
        __focusPrecio,
        __focusPlaca,
        saltarFila,
        saltarCampo
      })
    }
  }

  const keyUpPrecioInputHandler = e => {
    const keyCode = e.keyCode

    let __focusCantidad = false
    let __focusPrecio = true
    let __focusDescuento = false
    let __focusPlaca = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      if (__adminContext.valoresConfiguracionCompania.flagGrifo && idSocio) {
        __focusPrecio = false
        __focusPlaca = true
        saltarFila = false
        saltarCampo = true
      } else {
        __focusPrecio = false
        saltarFila = true
        saltarCampo = true
      }
    }

    actualizarFilaHandler({
      ...row,
      tipoInputCantidad,
      cantidad,
      precio,
      __focusCantidad,
      __focusPrecio,
      __focusDescuento,
      __focusPlaca,
      saltarFila,
      saltarCampo
    })
  }

  const clickCambiarInputASelect = () => {
    let __focusCantidad = false
    let __focusPrecio = false
    let __focusDescuento = false
    let saltarFila = false
    let saltarCampo = false

    const selectedPrecio = row.precios[0]
    let _idProductoPresentacionPrecio = selectedPrecio._id
    let precio = selectedPrecio.precio

    setTipoInputCantidad('select')

    actualizarFilaHandler({
      ...row,
      tipoInputCantidad: 'select',
      cantidad,
      _idProductoPresentacionPrecio,
      precio,
      __focusCantidad,
      __focusPrecio,
      __focusDescuento,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownPrecioHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const changePlacaHandler = e => {
    const selectedValue = e.target.value

    setIdPlacaSocio(selectedValue)

    let __focusCantidad = false
    let __focusPrecio = false
    let __focusPlaca = true
    let __focusDescuento = false
    let saltarFila = false
    let saltarCampo = false

    actualizarFilaHandler({
      ...row,
      tipoInputCantidad,
      cantidad,
      precio,
      _idPlacaSocio: selectedValue,
      __focusCantidad,
      __focusPrecio,
      __focusPlaca,
      __focusDescuento,
      saltarFila,
      saltarCampo
    })
  }

  const keyUpPlacaHandler = e => {
    const keyCode = e.keyCode

    if (keyCode === 13 || keyCode === 9) {
      let __focusPlaca = false
      let __focusCantidad = false
      let __focusPrecio = false
      let __focusDescuento = false
      let saltarFila = true
      let saltarCampo = true

      actualizarFilaHandler({
        ...row,
        cantidad,
        precio,
        _idPlacaSocio,
        __focusPlaca,
        __focusCantidad,
        __focusPrecio,
        __focusDescuento,
        saltarFila,
        saltarCampo
      })
    }
  }

  const keyDownPlacaHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const clickAplicarDescuentoHandler = () => {
    window.setTimeout(() => {
      setMostrarAplicarDescuentoModal(true)
    }, 150)
  }

  const actualizarDescuentoHandler = data => {
    setMostrarAplicarDescuentoModal(false)
    actualizarFilaHandler({
      ...row,
      ...data
    })
  }

  const onChangeCheckboxHandler = () => {
    const nuevoValor = !flagGratuito

    setFlagGratuito(nuevoValor)
    actualizarFilaHandler({
      ...row,
      flagGratuito: nuevoValor
    })
  }

  const clickActualizarComentarioHandler = () => {
    window.setTimeout(() => {
      setMostrarActualizarComentarioModal(true)
    }, 150)
  }

  const actualizarComentarioInnerHandler = ({ comentario }) => {
    setMostrarActualizarComentarioModal(false)
    actualizarComentarioHandler({
      ...row,
      comentario
    })
  }

  const clickEliminarFilaHandler = () => {
    window.setTimeout(() => {
      eliminarFilaHandler(row._idFila)
    }, 150)
  }

  const inputCantidadRef = React.useRef()
  React.useEffect(() => {
    if (!row.flagAnticipo && !row.flagCodigoBarra) {
      if (row.__filaActiva && row.__focusCantidad) {
        window.setTimeout(() => {
          inputCantidadRef.current.select()
        }, 250)
      }
    }
  }, [row.__filaActiva, row.__focusCantidad, row.flagAnticipo, row.flagCodigoBarra])

  const inputPrecioRef = React.useRef()
  React.useEffect(() => {
    if (row.flagAnticipo && !row.flagCodigoBarra) {
      if (row.__filaActiva && row.__focusCantidad) {
        window.setTimeout(() => {
          inputPrecioRef.current.select()
        }, 250)
      }
    }
  }, [row.__filaActiva, row.__focusCantidad, row.flagAnticipo, row.flagCodigoBarra])

  // eslint-disable-next-line
  React.useEffect(() => {
    if (flagNota13) {
      // eslint-disable-next-line
      actualizarFilaHandler({
        ...row
      })
    }
    // eslint-disable-next-line
  }, [flagNota13])

  return (
    <>
      <tr>
        <td className='text-center'>{parseFloat(index) + 1}</td>
        <td className='text-center'>{row.codigoProducto || '--'}</td>
        <td>
          {row.nombreProducto || '--'} {row.flagPromocionOrigen ? '(PROMO)' : ''}
        </td>
        <td>
          {row.flagAnticipo ? (
            row.cantidad || '--'
          ) : (
            <>
              {flagEditarComentarios ? (
                <>{row.cantidad}</>
              ) : (
                <Form.InputText
                  ref={inputCantidadRef}
                  className='text-center'
                  value={cantidad}
                  onChange={e => {
                    if (!flagPermitirVentaSinStock && parseFloat(e.target.value) > row.stock) {
                      __zariContext.snack('error', "La cantidad no puede ser mayor al stock disponible.")
                    } else {
                      setCantidad(e.target.value)
                    }
                  }}
                  onKeyUp={keyUpCantidadHandler}
                  onKeyDown={keyDownCantidadHandler}
                />
              )}
            </>
          )}
        </td>
        <td className='text-center'>{row.nombreUnidadDeMedida || '--'}</td>
        {/* {__adminContext.valoresConfiguracionUsuario.permisoVentas_Precio ? ( */}
        <td>
          {flagEditarComentarios || !flagModificarPrecioVenta ? (
            // <>{precio}</>
            <>
              <Form.InputGroup>
                <Form.InputText
                  className='text-center'
                  value={precio}
                  onChange={e => setPrecio(e.target.value)}
                  disabled
                />
              </Form.InputGroup>
            </>
          ) : (
            <>
              {row.flagAnticipo ||
                (row.precios && row.precios.length === 1) ||
                (row.precios && row.precios.length === 0) ||
                tipoInputCantidad === 'text' ? (
                <>
                  <Form.InputGroup>
                    <Form.InputText
                      ref={inputPrecioRef}
                      className='text-center'
                      value={precio}
                      autoFocus={row.__filaActiva && row.__focusPrecio}
                      onChange={e => setPrecio(e.target.value)}
                      onKeyUp={keyUpPrecioInputHandler}
                      onKeyDown={keyDownPrecioHandler}
                    />
                    {row.precios && row.precios.length > 1 && (
                      <Form.InputGroup.Append>
                        <Button onClick={clickCambiarInputASelect} tiny>
                          o
                        </Button>
                      </Form.InputGroup.Append>
                    )}
                  </Form.InputGroup>
                </>
              ) : (
                <>
                  <Form.InputGroup>
                    <Form.Select
                      value={row._idProductoPresentacionPrecio}
                      onChange={e => changePrecioHandler(e)}
                      autoFocus={row.__filaActiva && row.__focusPrecio}
                      onKeyUp={keyUpPrecioSelectHandler}
                      onKeyDown={keyDownPrecioHandler}
                    >
                      {row.precios.map((val, key) => (
                        <option key={key} value={val._id}>
                          {val.precio} ({val.precioListaNombre})
                        </option>
                      ))}
                    </Form.Select>
                    <Form.InputGroup.Append>
                      <Button onClick={() => setTipoInputCantidad('text')} tiny>
                        o
                      </Button>
                    </Form.InputGroup.Append>
                  </Form.InputGroup>
                </>
              )}
            </>
          )}
        </td>
        <td className='text-center'>{flagGratuito || flagNota13 ? '0.00' : row.subTotal || '0.00'}</td>
        <td className='text-center'>{flagGratuito || flagNota13 ? '0.00' : row.descuentoMonto || '0.00'}</td>
        <td className='text-center'>{flagGratuito || flagNota13 ? '0.00' : row.total || '0.00'}</td>
        <td className='text-center'>
          <Form.Checkbox
            id={`check-${row._idFila}`}
            checked={flagGratuito}
            onChange={onChangeCheckboxHandler}
            label=''
          />
        </td>
        {__adminContext.valoresConfiguracionCompania.flagGrifo && (
          <td>
            <PlacaSelect
              keyUpPlacaHandler={keyUpPlacaHandler}
              keyDownPlacaHandler={keyDownPlacaHandler}
              flagEditarComentarios={flagEditarComentarios}
              idPlacaSocio={_idPlacaSocio}
              setIdPlacaSocio={setIdPlacaSocio}
              idSocio={idSocio}
              index={index}
              autoFocus={row.__filaActiva && row.__focusPlaca}
              changePlacaHandler={changePlacaHandler}
            />
          </td>
        )}
        {flagEditarComentarios ? (
          <>
            <td>
              <Table.Dropdown>
                {({ handleClose }) => [
                  <Table.Dropdown.Item
                    key='centro-costo'
                    handleClose={handleClose}
                    onClick={w => setMostrarActualizarCentroCostoModal(true)}
                  >
                    Centro Costo
                  </Table.Dropdown.Item>,
                  <Table.Dropdown.Item
                    key='historial-compras'
                    handleClose={handleClose}
                    onClick={w => setMostrarModalHistorialCompras(true)}
                  >
                    Ver Compras
                  </Table.Dropdown.Item>,
                  <Table.Dropdown.Item
                    key='comentario'
                    handleClose={handleClose}
                    onClick={clickActualizarComentarioHandler}
                  >
                    Comentario
                  </Table.Dropdown.Item>
                ]}
              </Table.Dropdown>
            </td>
          </>
        ) : (
          <>
            <td>
              <Table.Dropdown>
                {({ handleClose }) => [
                  <Table.Dropdown.Item
                    key='centro-costo'
                    handleClose={handleClose}
                    onClick={w => setMostrarActualizarCentroCostoModal(true)}
                  >
                    Centro Costo
                  </Table.Dropdown.Item>,
                  <Table.Dropdown.Item
                    key='historial-compras'
                    handleClose={handleClose}
                    onClick={w => setMostrarModalHistorialCompras(true)}
                  >
                    Ver Compras
                  </Table.Dropdown.Item>,
                  <Table.Dropdown.Item
                    key='historial-stocks-sedes'
                    handleClose={handleClose}
                    onClick={w => setMostrarStockSedesModal(true)}
                  >
                    Ver Stocks
                  </Table.Dropdown.Item>,
                  <Table.Dropdown.Item
                    key='aplicarDescuento'
                    handleClose={handleClose}
                    onClick={clickAplicarDescuentoHandler}
                  >
                    Aplicar Descuento
                  </Table.Dropdown.Item>,
                  <Table.Dropdown.Item
                    key='comentario'
                    handleClose={handleClose}
                    onClick={clickActualizarComentarioHandler}
                  >
                    Comentario
                  </Table.Dropdown.Item>,
                  <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={clickEliminarFilaHandler}>
                    Eliminar
                  </Table.Dropdown.Item>
                ]}
              </Table.Dropdown>
            </td>
          </>
        )}
      </tr>
      {mostrarAplicarDescuentoModal && (
        <AplicarDescuentoModal
          handleClose={e => setMostrarAplicarDescuentoModal(false)}
          show={mostrarAplicarDescuentoModal}
          modalData={row}
          actualizarDescuentoHandler={actualizarDescuentoHandler}
        />
      )}
      {mostrarActualizarComentarioModal && (
        <ActualizarComentarioModal
          handleClose={e => setMostrarActualizarComentarioModal(false)}
          show={mostrarActualizarComentarioModal}
          modalData={row}
          actualizarComentarioHandler={actualizarComentarioInnerHandler}
        />
      )}
      {mostrarModalHistorialCompras && (
        <HistorialComprasModal
          handleClose={e => setMostrarModalHistorialCompras(false)}
          show={mostrarModalHistorialCompras}
          idProductoPresentacion={row._idProductoPresentacion}
        />
      )}
      {mostrarStockSedesModal && (
        <StockSedesModal
          handleClose={e => setMostrarStockSedesModal(false)}
          show={mostrarStockSedesModal}
          idProductoPresentacion={row._idProductoPresentacion}
        />
      )}
      {mostrarActualizarCentroCostoModal && (
        <ActualizarCentroCostoModal
          handleClose={e => setMostrarActualizarCentroCostoModal(false)}
          show={mostrarActualizarCentroCostoModal}
          actualizarFilaHandler={actualizarFilaHandler}
          modalData={row}
        />
      )}
    </>
  )
}

export default React.memo(FilaDetalleTemplate)
